import { render } from "./AliquotComponent.vue?vue&type=template&id=842e5b42&scoped=true"
import script from "./AliquotComponent.vue?vue&type=script&lang=js"
export * from "./AliquotComponent.vue?vue&type=script&lang=js"

import "./AliquotComponent.vue?vue&type=style&index=0&id=842e5b42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-842e5b42"]])

export default __exports__